import React, { useState } from 'react';
import { faqCategories } from '../mock';
import PageHero from '../components/shared/PageHero';
import FaqAccordion from '../components/shared/FaqAccordion';
import { Wallet, ShieldCheck, TrendingUp, HelpCircle, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const iconMap = { Wallet, ShieldCheck, TrendingUp, HelpCircle };

export default function Faq() {
  const [active, setActive] = useState(faqCategories[0].id);
  const [query, setQuery] = useState('');

  const current = faqCategories.find((c) => c.id === active);
  const filtered = query
    ? current.items.filter(
        (i) => i.q.toLowerCase().includes(query.toLowerCase()) || i.a.toLowerCase().includes(query.toLowerCase())
      )
    : current.items;

  return (
    <>
      <PageHero
        eyebrow="Support Center"
        title={<>Frequently Asked <span className="text-emerald-600">Questions</span></>}
        subtitle="Find answers to common questions about our services."
        ctaTo=""
      />

      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          {/* Search */}
          <div className="max-w-xl mx-auto mb-10">
            <Input
              placeholder="Search FAQs..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="h-12 text-base"
            />
          </div>

          {/* Category tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {faqCategories.map((c) => {
              const Icon = iconMap[c.icon];
              return (
                <button
                  key={c.id}
                  onClick={() => setActive(c.id)}
                  className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all ${
                    active === c.id
                      ? 'bg-emerald-600 text-white shadow'
                      : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                  }`}
                >
                  <Icon className="w-4 h-4" /> {c.label}
                </button>
              );
            })}
          </div>

          <div className="rounded-2xl bg-white border border-slate-200 shadow-sm px-6 lg:px-10 py-2">
            {filtered.length > 0 ? (
              <FaqAccordion items={filtered} />
            ) : (
              <p className="py-10 text-center text-slate-500">No results found. Try a different search.</p>
            )}
          </div>

          <div className="mt-14 rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100 p-8 text-center">
            <h3 className="font-serif-display text-2xl font-bold text-slate-900">Not finding what you're looking for?</h3>
            <p className="mt-2 text-slate-600">Our customer support team is ready to help with any questions you may have.</p>
            <a href="mailto:info@theloanalliance.com" className="inline-block mt-5">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white h-11 px-6">
                <Mail className="mr-2 h-4 w-4" /> Email Us
              </Button>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
